import { render, staticRenderFns } from "./Nyugta.vue?vue&type=template&id=0f500f0b&scoped=true"
import script from "./Nyugta.vue?vue&type=script&lang=js"
export * from "./Nyugta.vue?vue&type=script&lang=js"
import style0 from "./Nyugta.vue?vue&type=style&index=0&id=0f500f0b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f500f0b",
  null
  
)

export default component.exports